/** The read-only pieces of SubmissionDialog (in SubmitIdeaDialog.tsx). */

import { ExternalLink } from 'lucide-react';

import type { IdeaDetail } from '@/api/types';

const INDUSTRY_SOURCE_HINT: Partial<Record<NonNullable<IdeaDetail['industry_source']>, string>> = {
  ai: 'Suggested by AI research.',
  admin: 'Set by an admin.',
};

export function industryText(idea: IdeaDetail): string {
  if (!idea.industry) return 'Not sure / cross-industry';
  return `${idea.industry.name}${idea.industry.status === 'pending' ? ' (pending review)' : ''}`;
}

export function industryHint(idea: IdeaDetail): string {
  const bySource = idea.industry_source ? INDUSTRY_SOURCE_HINT[idea.industry_source] : undefined;
  if (bySource) return bySource;
  return idea.industry ? 'Chosen by the submitter.' : 'Left open for research to suggest.';
}

export function SubmissionSources({ urls }: { urls: string[] }) {
  return (
    <fieldset className="field field-group">
      <legend className="label">Source URLs</legend>
      {urls.length > 0 ? (
        <div className="url-list">
          {urls.map((url, index) => (
            <div key={url} className="url-row">
              <input type="url" readOnly value={url} aria-label={`Source URL ${index + 1}`} />
              <a href={url} target="_blank" rel="noopener noreferrer" className="icon-btn" aria-label={`Open source URL ${index + 1}`} title="Open in a new tab">
                <ExternalLink aria-hidden="true" />
              </a>
            </div>
          ))}
        </div>
      ) : (
        <span className="hint">None given.</span>
      )}
    </fieldset>
  );
}
